import { render, staticRenderFns } from "./Propose_a_plan.vue?vue&type=template&id=6e0d1e61&scoped=true"
import script from "./Propose_a_plan.vue?vue&type=script&lang=js"
export * from "./Propose_a_plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d1e61",
  null
  
)

export default component.exports